export default __webpack_public_path__ + "static/lsa-screens-2-mobile-2892e45a0bc0c243818ec795d1569652.jpg";